import React from 'react';
import TodoContainer from 'components/todo/TodoContainer';

function App() {
  return (
    <div className="App">
      <TodoContainer />
      
    </div>
  );
}

export default App;
